const icons = require.context('../assets/img/logos/', false, /\.png$/);

function iconUrl(icon){
  return icons('./' + icon)
}

const defaultProfileStatistic = {
  daysList: {}
}

const recommendedLinks = [{
  id: 1,
  icon: iconUrl('youtube_kids.png'),
  title: 'YouTube Kids',
  domain: 'youtubekids.com',
  desc: 'YouTube Kids is an American children\'s video app developed by YouTube, a subsidiary of Google. ',
  url: 'https://www.youtubekids.com/',
  rating: 5,
},{
  id: 2,
  icon: iconUrl('disney.png'),
  title: 'Disney',
  domain: 'disneyplus.com',
  desc: 'The mission of The Walt Disney Company is to entertain, inform and inspire people around the globe through the power of unparalleled storytelling, reflecting the iconic brands, creative minds and innovative technologies that make ours the world’s premier entertainment company.',
  url: 'https://www.disneyplus.com/',
  rating: 5,
  validLinks: ['https://www.preview.disneyplus.com/unavailable/', 'https://www.disneyinternational.com/']
},{
  id: 3,
  icon: iconUrl('babytv.png'),
  title: 'Baby TV',
  domain: 'babytv.com',
  desc: 'BabyTV is the world’s most widely distributed TV network created especially for toddlers and their parents, helping them discover the world around them.',
  url: 'https://babytv.com/',
  rating: 5
},{
  id: 4,
  icon: iconUrl('primary_games.png'),
  title: 'PrimaryGames',
  domain: 'primarygames.com',
  desc: 'PrimaryGames is the fun place to learn and play!',
  url: 'https://www.primarygames.com/all_games_a-z/',
  rating: 5
},{
  id: 5,
  icon: iconUrl('sesame_street.png'),
  title: 'Sesame Street',
  domain: 'sesamestreet.org',
  desc: '',
  url: 'https://www.sesamestreet.org/',
  rating: 5
},{
  id: 6,
  icon: iconUrl('timetokids.png'),
  title: 'Time For Kids',
  domain: 'timeforkids.com',
  desc: '',
  url: 'https://www.timeforkids.com/',
  rating: 5
},{
  id: 7,
  icon: iconUrl('coolmath.png'),
  title: 'Coolmath',
  domain: 'coolmath.com',
  desc: 'Cool Math is a brain-training site, for everyone, where logic &amp; thinking &amp; math meets fun &amp; games. These games have no violence, no empty action, just a lot of challenges that will make you forget you&039;re getting a mental workout!',
  url: 'https://www.coolmath.com/',
  rating: 5
},{
  id: 8,
  icon: iconUrl('pbs.png'),
  title: 'Pbskids',
  domain: 'pbskids.org',
  desc: 'Educational games and videos from Curious George, Wild Kratts and other PSB KIDS shows',
  url: 'https://pbskids.org/',
  rating: 5
},{
  id: 9,
  icon: iconUrl('nationalgeog.png'),
  title: 'Kids National Geographic',
  domain: 'kids.nationalgeographic.com',
  desc: 'National Geographic Kids Videos',
  url: 'https://kids.nationalgeographic.com/',
  rating: 5
},{
  id: 10,
  icon: iconUrl('howstuffworks.png'),
  title: 'How Stuff Works',
  domain: 'howstuffworks.com',
  desc: '',
  url: 'https://www.howstuffworks.com/',
  rating: 5,
  validLinks: [
    'https://health.howstuffworks.com/diseases-conditions/infectious/delta-variant-coronavirus-news.htm',
    'https://health.howstuffworks.com/medicine/tests-treatment/personality-tests.htm',
    'https://home.howstuffworks.com/green-living/bamboo-toilet-paper.htm',
    'https://money.howstuffworks.com/how-to-write-bill-of-sale.htm',
    'https://entertainment.howstuffworks.com/tokyo-olympics-news.htm',
    'https://people.howstuffworks.com/executive-order.htm',
    'https://entertainment.howstuffworks.com/what-happens-olympic-torch-extinguished.htm',
    'https://science.howstuffworks.com/environmental/earth/geology/rose-quartz.htm',
    'https://electronics.howstuffworks.com/tech',
    'https://science.howstuffworks.com/',
    'https://science.howstuffworks.com/nature/natural-disasters/nyiragongo-volcano-news.htm',
    'https://entertainment.howstuffworks.com/',
    'https://science.howstuffworks.com/no-moon.htm',
    'https://health.howstuffworks.com/human-body/systems/nose-throat/parosmia.htm',
    'https://entertainment.howstuffworks.com/olympics-skipped.htm',
    'https://money.howstuffworks.com/',
    'https://entertainment.howstuffworks.com/arts/literature/humpty-dumpty.htm',
    'https://history.howstuffworks.com/world-war-ii/wwii-pow-olympics.htm',
    'https://reviews.howstuffworks.com/',
    'https://science.howstuffworks.com/nasa-moon-trees.htm',
    'https://history.howstuffworks.com/american-civil-war/devils-den.htm',
    'https://science.howstuffworks.com/environmental/earth/geology/ocean-diamonds.htm',
    'https://entertainment.howstuffworks.com/surfing-olympic-debut-news.htm',
    'https://history.howstuffworks.com/historical-figures/emmett-till.htm',
    'https://health.howstuffworks.com/',
    'https://entertainment.howstuffworks.com/tokyo-olympic-athletes-news.htm',
    'https://entertainment.howstuffworks.com/olympic-decathlon-winner-best-athlete-in-world.htm',
    'https://animals.howstuffworks.com/',
    'https://lifestyle.howstuffworks.com/',
    'https://people.howstuffworks.com/sommerloch.htm',
    'https://home.howstuffworks.com/',
    'https://science.howstuffworks.com/nature/natural-disasters/western-us-drought-news.htm',
    'https://recipes.howstuffworks.com/bitters.htm',
    'https://science.howstuffworks.com/jupiter-have-79-moons-when-earth-just-has-one.htm',
    'https://people.howstuffworks.com/culture',
    'https://auto.howstuffworks.com/',
    'https://computer.howstuffworks.com/internet/social-networking/information/get-rid-of-ads-on-facebook.htm',
    'https://science.howstuffworks.com/nature/natural-disasters/100-year-flood-news.htm',
    'https://home.howstuffworks.com/home-improvement/heating-and-cooling/swamp-cooler.htm',
    'https://science.howstuffworks.com/environmental/earth/geology/high-deserts.htm',
    'https://science.howstuffworks.com/is-blue-moon-really-blue.htm',
    'https://people.howstuffworks.com/racketeering.htm',
    'https://science.howstuffworks.com/why-does-hydrogen-peroxide-come-in-brown-bottle.htm',
    'https://play.howstuffworks.com/',
    'https://science.howstuffworks.com/environmental/earth/oceanography/southern-ocean-news.htm',
    'https://computer.howstuffworks.com/ransomware-attacks-news.htm',
    'https://science.howstuffworks.com/moonrise-and-sunset-together.htm',
    'https://people.howstuffworks.com/10-historical-words-that-dont-mean-what-you-think.htm',
    'https://entertainment.howstuffworks.com/countries-dominate-olympics.htm',
    'https://science.howstuffworks.com/superb-moon-quiz.htm',
    'https://adventure.howstuffworks.com/'
  ]
}]

const defaultProfileSettings = {
  kidName: "",
  kidAge: "5-8",
  dailyLimit: 86400, /*seconds*/
  todayDailyLimit: 86400,
  dailyLimitUsed: 0, /*seconds*/
  allowKidRequestSite: true,
  defaultAvatarId: 13,
  avatar: null,
  theme: 1,
  popupOpen: false,
  uploadedThemes: [],
  links: recommendedLinks.slice(2),
  availableTime: [
    {
      id: 0,
      name: 'Su',
      isActive: false,
      allDay: false,
      periods: null
    },
    {
      id: 1,
      name: 'Mo',
      isActive: false,
      allDay: false,
      periods: null
    },
    {
      id: 2,
      name: 'Tu',
      isActive: false,
      allDay: false,
      periods: null
    },
    {
      id: 3,
      name: 'We',
      isActive: false,
      allDay: false,
      periods: null
    },
    {
      id: 4,
      name: 'Th',
      isActive: false,
      allDay: false,
      periods: null
    },
    {
      id: 5,
      name: 'Fr',
      isActive: false,
      allDay: false,
      periods: null
    },
    {
      id: 6,
      name: 'Sa',
      isActive: false,
      allDay: false,
      periods: null
    }
  ],
  requests: null,
  statistic: defaultProfileStatistic
};

const guestProfileSettings = {
  created: true,
  kidName: 'Guest',
  todayDailyLimit: 1800,
  theme: 1,
  links: recommendedLinks.slice(0, 2),
  allowAllLinks: false,
};

const defaultUserSettings = {
  profiles: {
    defaultProfileSettings,
  },
  password: "",
  isPremium: false,
  premiumEnd: null,
  customer: [],
  showWelcome: false,
  resetDate: new Date().toDateString()
}

const recommendedLinksPopup = [{
  title: 'ABCmouse',
  desc: 'ABCmouse. com helps kids learn to read through phonics, and teaches lessons in math, social studies, art, music, and much more. For kids age 2 to Kindergarten.',
  url: 'https://www.abcmouse.com',
  rating: 5,
  category: 'Education',
  age: '5-8'
},{
  title: 'Young Ocean Explorers',
  desc: 'Young Ocean Explorers has been on a mission since 2012 to inspire kids to love our ocean - through entertaining education. We want to capture children\'s imagination through great storytelling, bringing the beauty, awe and fascination of the ocean and its inhabitants alive.',
  url: 'https://www.youngoceanexplorers.com/',
  rating: 5,
  category: 'Education',
  age: 'all'
},{
  title: 'Funbrain',
  desc: 'At Funbrain, our range of Educational videos educate your children to engage in learning that\'s fun and entertaining. Check out our Pre-K to Grade 8 videos, here.',
  url: 'https://www.funbrain.com/',
  rating: 5,
  category: 'Education',
  age: 'all'
},{
  title: 'Shuan\'s Game Academy',
  desc: 'Shuan\'s Game Academy is a suite of learning resources targeted at 8-12 years old (but for everyone!), teaching the principles of game design and how to make games in Scratch. Plus there are awesome prizes to be won!',
  url: 'https://www.shaunsgameacademy.co.uk',
  rating: 5,
  category: 'Education',
  age: 'all'
},{
  title: 'Oxford Owl',
  desc: 'Discover the expert advice, educational resources and free ebooks to support children\'s learning at primary school and at home, from Oxford University Press',
  url: 'https://www.oxfordowl.co.uk/',
  rating: 5,
  category: 'Education',
  age: 'all'
},{
  title: 'Pbskids',
  desc: 'Educational games and videos from Curious George, Wild Kratts and other PSB KIDS shows',
  url: 'https://pbskids.org/',
  rating: 5,
  category: 'Education',
  age: '5-8'
},{
  title: 'Starfall',
  desc: 'At Starfall, children have fun while they learn - specializing in reading, phonics & math- educational games, movies, books, songs, and more for children k-3.',
  url: 'https://www.starfall.com/h/',
  rating: 5,
  category: 'Education',
  age: '5-8'
},{
  title: 'Cool Math For Kids',
  desc: 'Math and Games for Kids, Teachers and Parents. Math lessons and fun games for kindergarten to sixth grade, plus quizzes, brain teasers and more.',
  url: 'https://www.coolmath4kids.com/',
  rating: 5,
  category: 'Education',
  age: 'all'
},{
  title: 'Bill Nye',
  desc: 'The official website of Bill Nye The Science Guy featuring books, shows, appearances, episode guides, and home demos.',
  url: 'https://billnye.com/',
  rating: 5,
  category: 'Education',
  age: '9-12'
},{
  title: 'Scratch',
  desc: 'Scratch is a free programming language and online community where you can create your own interactive stories, games and animation',
  url: 'https://scratch.mit.edu/',
  rating: 5,
  category: 'Education',
  age: '9-12'
},{
  title: 'Thekidzpage',
  desc: 'We offer you a growing collection of flashcards, worksheets, free coloring pages, stories for kids, Alphabet pictures',
  url: 'http://thekidzpage.com/',
  rating: 5,
  category: 'Education',
  age: '5-8'
},{
  title: 'National Geographic',
  desc: 'National Geographic Kids Videos',
  url: 'https://kids.nationalgeographic.com/',
  rating: 5,
  category: 'Education',
  age: 'all'
},{
  title: 'Howstuffworks',
  desc: 'HowStuffWorks creates great content describing how the world actually works',
  url: 'https://maths.howstuffworks.com/',
  rating: 5,
  category: 'Education',
  age: '9-12'
},{
  title: 'Kidzbop',
  desc: 'Watch all the latest official music videos from the KIDZ BOP Kids',
  url: 'https://kidzbop.com/videos/',
  rating: 5,
  category: 'Video',
  age: 'all'
},{
  title: 'Neok 12',
  desc: 'Teachers! Make your class fun and interactive with interesting videos, games & activities for 100+ K12 topics. Improve student motivation, learning education, teach, learn, school',
  url: 'https://www.neok12.com/',
  rating: 5,
  category: 'Video',
  age: '9-12'
},{
  title: 'WB Kids Go',
  desc: 'WB Kids Go! - DC Kids- WB Parents- Games, Movies- and so much more! | WB Kids Go! DC Kids',
  url: 'https://www.wbkidsgo.com/',
  rating: 5,
  category: 'Video',
  age: 'all'
},{
  title: 'Pbskids Video',
  desc: 'Watch videos and full episodes of your favorite PSB KIDS shows like Curious George, Dinosaur Train and Sesame Street!',
  url: 'https://pbskids.org/video/',
  rating: 5,
  category: 'Video',
  age: '5-8'
},{
  title: 'YouTube Kids',
  desc: 'YouTube Kids provides a more contained environment for kids to explore YouTube and makes it easier for parents and caregivers to guide their journey.',
  url: 'https://www.youtubekids.com/',
  rating: 5,
  category: 'Video',
  age: 'all'
},{
  title: 'Cartoon Networkhq',
  desc: 'Cartoon network is the home of your favourite kids cartoons online- with great free videos, online games pictures, activities and competitions from cartoon shows like Been 10, adventure Time and Gumball',
  url: 'https://www.cartoonnetworkhq.com/',
  rating: 5,
  category: 'Video',
  age: 'all'
},{
  title: 'Watch Know Learn',
  desc: 'More than 50,000 educational videos are divided into around 5,000 categories for all life-long learners!',
  url: 'http://www.watchknowlearn.org/default.aspx',
  rating: 5,
  category: 'Video',
  age: '9-12'
},{
  title: 'Gonoodle',
  desc: 'GoNoodle engages and inspires millions of kids every month to channel their boundless energy–getting them up, moving and becoming more mindful. Created by child development experts, you can join for free at school, home, and everywhere kids are!',
  url: 'https://www.gonoodle.com/',
  rating: 5,
  category: 'Video',
  age: '9-12'
},{
  title: 'Nick Jr.',
  desc: 'Nick Jr. provided educational and entertaining programming to encourage preschoolers to learn, play and have fun.',
  url: 'https://www.nickjr.tv/',
  rating: 5,
  category: 'Games',
  age: 'all'
},{
  title: 'Adventure Academy',
  desc: 'From the creators of ABCmouse.com, Adventure Academy is the newest education product from Age of Learning Inc. featuring endless game play. Adventure Academy is an educational product that combines an Elementary School curriculum with an interactive 3D world.',
  url: 'https://www.adventureacademy.com/',
  rating: 5,
  category: 'Games',
  age: '9-12'
},{
  title: 'Coolmathgames',
  desc: 'Cool Math Games is a brain-training site, for everyone, where logic &amp; thinking &amp; math meets fun &amp; games. These games have no violence, no empty action, just a lot of challenges that will make you forget you&039;re getting a mental workout!',
  url: 'https://www.coolmathgames.com/',
  rating: 5,
  category: 'Games',
  age: 'all'
},{
  title: 'Sheppard Software',
  desc: 'Hundred of fun educational games and activities for kids to play online. Topics include math, geography, animals and more.',
  url: 'https://www.sheppardsoftware.com/',
  rating: 5,
  category: 'Games',
  age: 'all'
},{
  title: 'Pbskids Games',
  desc: 'Play games with your PSB KIDS favorites like Curious George, Wild Kratts, Daniel Tiger and Peg + Cat!',
  url: 'https://pbskids.org/games/',
  rating: 5,
  category: 'Games',
  age: 'all'
},{
  title: 'Primary Games',
  desc: 'Play free online games featuring The best action games, fun games, puzzle games, learning games and racing games from PrimaryGames! Celebrate the holidays and seasons with crafts, printables, postcards, coloring pages, games and more! Watch videos and cartoons. All games are safe and free to play online.',
  url: 'https://www.primarygames.com/all_games_a-z/',
  rating: 5,
  category: 'Games',
  age: 'all'
},{
  title: 'ABCya',
  desc: 'ABCya! Educational Computer Games and Apps for Kids.',
  url: 'https://www.abcya.com/',
  rating: 5,
  category: 'Games',
  age: 'all'
},{
  title: 'Education Games',
  desc: 'Your kids will love learning with our math and reading games. Have fun and watch their skills grow. Try now for free!',
  url: 'https://www.education.com/games/',
  rating: 5,
  category: 'Games',
  age: 'all'
},{
  title: 'Mrnussbaum',
  desc: 'Best and most original and creative learning games in all subjects for kids in grades K-8.',
  url: 'https://mrnussbaum.com/games',
  rating: 5,
  category: 'Games',
  age: 'all'
},{
  title: 'Tynker',
  desc: 'Meta description: games, a project made by Spiteful Belltower using Tynker. Learn to code and make your own app or game in minutes.',
  url: 'https://www.tynker.com/dashboard/student/#/dashboard',
  rating: 5,
  category: 'Games',
  age: 'all'
},{
  title: 'Sumdog',
  desc: 'Engage your students with adaptive learning and multiplayer games.',
  url: 'https://www.sumdog.com/en/',
  rating: 5,
  category: 'Games',
  age: 'all'
},{
  title: 'Ducksters',
  desc: 'A great variety of educational and funny games including word, puzzle, math, geography, arcade, sports, and typing games',
  url: 'https://www.ducksters.com/games/',
  rating: 5,
  category: 'Games',
  age: 'all'
},{
  title: 'Kids-n-Fun',
  desc: 'Kids-n-Fun, the best site for kids and parents on the Internet, the place for coloring pages, craft tips, wallpaper and puzzles. Kids-n-Fun is a fun and safe website. Kids-n-Fun is a fun and safe website.',
  url: 'https://www.kids-n-fun.com/',
  rating: 5,
  category: 'Portal',
  age: '5-8'
},{
  title: 'CodaKid',
  desc: 'CodaKid is an online kids coding academy offering coding for Kids, Minecraft modding, Roblox coding, and video programming courses. Try today for FREE!',
  url: 'https://codakid.com/',
  rating: 5,
  category: 'Portal',
  age: '9-12'
},{
  title: 'Coolmathgames',
  desc: 'Cool Math Games is a brain-training site, for everyone, where logic &amp; thinking &amp; math meets fun &amp; games. These games have no violence, no empty action, just a lot of challenges that will make you forget you&039;re getting a mental workout!',
  url: 'https://www.coolmathgames.com/',
  rating: 5,
  category: 'Portal',
  age: '5-8'
},{
  title: 'Cool Math',
  desc: 'Cool Math is a brain-training site, for everyone, where logic &amp; thinking &amp; math meets fun &amp; games. These games have no violence, no empty action, just a lot of challenges that will make you forget you&039;re getting a mental workout!',
  url: 'https://www.coolmath.com/',
  rating: 5,
  category: 'Portal',
  age: '9-12'
},{
  title: 'Time4learning',
  desc: 'Award-winning online curriculum teaching math, language arts, science, social studies and more! Great for homeschool program, after school &amp; summer use.',
  url: 'https://www.time4learning.com/v3/',
  rating: 5,
  category: 'Portal',
  age: 'all'
},{
  title: 'Everydaymath',
  desc: 'Everyday Mathematics is grounded in an extensive body of research into how students learn',
  url: 'https://everydaymath.uchicago.edu/',
  rating: 5,
  category: 'Portal',
  age: 'all'
},{
  title: 'ABCya',
  desc: 'ABCya! Educational Computer Games and Apps for Kids.',
  url: 'https://www.abcya.com/',
  rating: 5,
  category: 'Portal',
  age: 'all'
},{
  title: 'IXL',
  desc: 'IXL is the world\'s most popular subscription-bases learning site for K-12. Used it over 12 million students, IXL provides personalized learning in more than 8,500 topics, covering math, language arts, science,social studies, and Spanish. Interactive questions, awards, and certificates keep kids motivated as they master skills.',
  url: 'https://www.ixl.com/',
  rating: 5,
  category: 'Portal',
  age: '9-12'
},{
  title: 'Hooked on Phonics',
  desc: 'Hooked on Phonics Digital Learning',
  url: 'https://subscriptions.hookedonphonics.com/read-with-hop/reader-today-leader-tomorrow?sscid=71k5_ibudb&utm_source=SAS288359&SSAID=288359&AFF_ID=288359&AFF_ID2=288359&VC=SHA1',
  rating: 5,
  category: 'Portal',
  age: '5-8'
},{
  title: 'ReadingIQ',
  desc: 'ReadingIQ helps kids ages 2-12, learn to read with thousands of digital books. Adventure & mysteries, fables & fairytales, animals & plants, and more.',
  url: 'https://www.readingiq.com/',
  rating: 5,
  category: 'Portal',
  age: 'all'
},{
  title: 'E-learning',
  desc: 'The source for childhood learning on the internet available from anywhere and without charge',
  url: 'https://www.e-learningforkids.org/',
  rating: 5,
  category: 'Portal',
  age: 'all'
},{
  title: 'Mathseeds',
  desc: 'Mathseeds teaches kids aged 3-9 core math and problem solving skills with fun online math games and activities. Try a FREE 30 day trial today!',
  url: 'https://mathseeds.co.uk/',
  rating: 5,
  category: 'Portal',
  age: '5-8'
},{
  title: 'Scratch',
  desc: 'Scratch is a free programming language and online community where you can create your own interactive stories, games and animation',
  url: 'https://scratch.mit.edu/',
  rating: 5,
  category: 'Portal',
  age: '9-12'
},{
  title: 'Pbskids Music',
  desc: 'Learn about music and play games with your favorite PSB KIDS character like Elmo, Arthur, Pinkalicious, and Daniel Tiger!',
  url: 'https://pbskids.org/games/music/',
  rating: 5,
  category: 'Music',
  age: '5-8'
},{
  title: 'Funbrain',
  desc: 'Suitable for all grades, memorize how the musical performers look. Play Music Memorizer online, here.',
  url: 'https://www.funbrain.com/games/music-memorizer',
  rating: 5,
  category: 'Music',
  age: 'all'
},{
  title: 'Putumayo',
  desc: 'The Putumayo Kids Corner is dedicated to providing fun and educational adventures for children. Discover the world through music albums, playlists and videos, fascinating books and activity sets',
  url: 'https://www.putumayo.com/kids-corner',
  rating: 5,
  category: 'Music',
  age: '5-8'
},{
  title: 'Creating Music',
  desc: 'A place for kids to compose music, play with musical performance, music games and music puzzles.',
  url: 'http://www.creatingmusic.com',
  rating: 5,
  category: 'Music',
  age: 'all'
},{
  title: 'Brainpop',
  desc: 'In BrainPOP\'s Arts & Music movies, you\'ll learn how folks use words, music, and images to express themselves! Plus, meet some famous artists and see their work.',
  url: 'https://www.brainpop.com/artsandmusic/',
  rating: 5,
  category: 'Music',
  age: 'all'
},{
  title: 'The New York Philharmonic Kidzone',
  desc: 'The New York Philharmonic Kidzone is a place for kids to come and learn about the New York Philharmonic and about the instrument, music, musicians, composers and conductors of symphony music.',
  url: 'http://www.nyphilkids.org/',
  rating: 5,
  category: 'Music',
  age: '5-8'
},{
  title: 'Sphinxkids',
  desc: 'Classical Music Interactive Learning and Games for Kids',
  url: 'http://www.sphinxkids.org/',
  rating: 5,
  category: 'Music',
  age: 'all'
},{
  title: 'MusicK8Kids',
  desc: 'MusicK8Kids.com\'s K8 KidTunes: Music And Other Fun Stuff Just For Kids.',
  url: 'https://www.musick8kids.com/',
  rating: 5,
  category: 'Music',
  age: 'all'
},{
  title: 'Doremi4kids',
  desc: 'Do Re Mi provides a unique music education experience for families in Mississauga. In both our classes and our private lessons, our goal is to provide our student with a well rounded education in all aspects of music. We offer programs for kids of all ages, from the very young to the young at heart.',
  url: 'https://doremi4kids.com/',
  rating: 5,
  category: 'Music',
  age: 'all'
},{
  title: 'Noteflight',
  desc: 'Noteflight Learn is a private website designed specifically for music education. Users have Premium features including performance and assessment tools.',
  url: 'https://Noteflight.com/',
  rating: 5,
  category: 'Music',
  age: '9-12'
},{
  title: 'DSO Kids',
  desc: 'DSO Kids give teachers &amp; students (k-6) music educational experiences &amp; opportunities from the symphony. Music lovers of all ages benefit',
  url: 'http://www.dsokids.com/',
  rating: 5,
  category: 'Music',
  age: '9-12',
  validLinks: ['https://www.dallassymphony.org']
},{
  title: 'Sesame Street',
  desc: 'These are challenging times, and your friends at Sesame Street are here to help. Our hub is filled with videos, playful learning activities. The Sesame Street Muppets are staying home, too, but still connecting with friends online',
  url: 'https://www.sesamestreet.org/',
  rating: 5,
  category: 'Portal',
  age: '9-12'
},{
  title: 'TIME for Kids',
  desc: 'From the publishers of TIME magazine, TIME for Kids is loaded with interesting articles, photos, and videos. Politics, the environment, entertainment, sports, and health are just some of the topics covered',
  url: 'https://www.timeforkids.com/',
  rating: 5,
  category: 'Portal',
  age: 'all'
},{
  title: 'BBC History for Kids',
  desc: 'Games, quizzes and fact sheets take kids on a journey through time. Kids can set off on a learning adventure when they walk through ancient history, world history and histories of specific countries on the BBC History for Kids website',
  url: 'http://www.bbc.co.uk/history/forkids/',
  rating: 5,
  category: 'Portal',
  age: '9-12'
}];

const notAvailableForMobileDomains = [
  'https://www.youtubekids.com/'
];

const recommendedLinksCategories = ['Education', 'Games', 'Video', 'Portal', 'Music'];

const sessionLimitOptions = [
  {
    label: '30 min',
    value: 1800,
  },
  {
    label: '1 hour',
    value: 3600,
  },
  {
    label: '1h 30m',
    value: 5400,
  },
  {
    label: '2 hours',
    value: 7200,
  },
  {
    label: '3 hours',
    value: 10800,
  },
  {
    label: '4 hours',
    value: 14400,
  },
  {
    label: 'Unlimited',
    value: 86400,
  },
];

const extensionLink = 'https://chrome.google.com/webstore/detail/kids-mode/bhgkffnlmkkimfbomibamhgoaecelckc'
const applicationLink = 'https://play.google.com/store/apps/details?id=com.branteur.kidsmode.new'
const mainUrl = 'https://kidsmode.net/app/#' // change to production
export {
  defaultUserSettings,
  defaultProfileSettings,
  defaultProfileStatistic,
  recommendedLinks,
  recommendedLinksPopup,
  notAvailableForMobileDomains,
  extensionLink,
  applicationLink,
  guestProfileSettings,
  mainUrl,
  recommendedLinksCategories,
  sessionLimitOptions,
}
